import { render, staticRenderFns } from "./EventbriteWidget.vue?vue&type=template&id=17720c0c&"
import script from "./EventbriteWidget.vue?vue&type=script&lang=ts&"
export * from "./EventbriteWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports